export default __webpack_public_path__ + "static/apteka-3461322c9173fc0d5f9993c5e7fffb55.png";